import "@app/App.css";
import FilterEditor from "@app/filter/FilterEditor";
import { Notification } from "@comps/ui/notification";
import { Popover, PopoverContent, PopoverTrigger } from "@comps/ui/popover";
import { FullRightAccess, ViewRightType, hasGlobalRightAccess } from "@dto/Users";
import { Filter } from "@dto/records";
import { preventDefaultIfNotRealUserInteraction } from "@utils/events";
import { TW_ObjectHeaderButtonTitle, TW_ObjectModelViewHeaderButton, TW_ObjectModelViewHeaderIcon } from "@utils/twClasses";
import { Sort } from "iconsax-react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDataStore, useModelStore, useUserStore } from "src/store";

interface FilterButtonProps {
  relationFilters?: Filter[];
  allowNewFilters?: boolean;
}

function FilterButton({ relationFilters = [], allowNewFilters = true }: FilterButtonProps) {

  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  const selectedObjectInfos = useModelStore((state) => state.selectedObjectInfos);
  const selectedView = useModelStore((state) => state.selectedView);
  const { t } = useTranslation();
  const user = useUserStore((state) => state.user);
  const userRole = useModelStore((state) => state.userRole);
  const rowActionsEnabled = useDataStore(state => state.rowActionsEnabled);
  const fields = selectedObjectInfos?.fields;

  const filter = selectedView?.filter;
  const filters = filter?.groupFilter?.filters || [];
  const numberOfFilters = filters.length + relationFilters.length;

  const onClose = () => {
    setIsPopoverOpen(false);
  }

  const hasFullAccess = selectedView?.ownerKey === user?._key || hasGlobalRightAccess(user, userRole, ViewRightType, FullRightAccess, selectedView?._key);
  const isDisabled = (!fields || fields.length === 0) || !rowActionsEnabled;
  return (
    <Popover open={isPopoverOpen} onOpenChange={setIsPopoverOpen}>
      <PopoverTrigger disabled={isDisabled} className={TW_ObjectModelViewHeaderButton + (isDisabled ? " opacity-50 cursor-not-allowed" : " opacity-100 cursor-default")}>
        <div className="flex flex-row justify-start items-center relative">
          <Sort className={TW_ObjectModelViewHeaderIcon} />
          {numberOfFilters > 0 && <Notification number={numberOfFilters} />}
        </div>
        <span className={TW_ObjectHeaderButtonTitle}>{t('object.header.button.filter.rows.title')}</span>
      </PopoverTrigger>
      <PopoverContent className="w-max" onInteractOutside={preventDefaultIfNotRealUserInteraction}>
        <FilterEditor filters={filters} relationFilters={relationFilters} onClose={onClose} disabled={!hasFullAccess} allowNewFilters={allowNewFilters} />
      </PopoverContent>
    </Popover>
  )
}

export default FilterButton;
